var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.153,
    height: 12.002,
    viewBox: "0 0 19.153 12.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.152 684) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-12086.846,14924.857l3.755-3.857h-15.757v-2h15.8l-3.8-3.832,1.154-1.169,6,5.972-6,6.03Z",
    transform: "translate(12404.847 -14242)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowicon);
export default __webpack_public_path__ + "static/media/left-arrow.icon.c8e6527930f5f29dcc415abec45b8f14.svg";
export { ForwardRef as ReactComponent };